import React from "react";
import Tree from "./Tree";
import "./SideBar.css";
const RightSideBar = ({ handleDragStart, explorerData, setExplorerData, actionNeeded, type, children }) => {
  return (
    <div className="rightsidebar">
      {children && (
        <div className="sidebar_top_header">
          {type} <div>{children}</div>
        </div>
      )}
      <div className="right_sidebar_body">
        <Tree
          explorerData={explorerData}
          setExplorerData={setExplorerData}
          folderData={explorerData}
          handleDragStart={handleDragStart}
          actionNeeded={actionNeeded}
        />
      </div>
    </div>
  );
};

export default RightSideBar;
